import { AsyncState } from "../../ui/async-state";

// The one answer to every refusal of the Analytics area: the same words for every cause (a role without the capability, a customer outside the
// scope, a missing or erased customer, a missing or expired opening). The page never tells the causes apart.

export function RefusedState() {
  return (
    <AsyncState
      kind="error"
      title="This customer is not available to you"
      message="You may open only the customers you are allowed to see. If you think this is a mistake, ask a supervisor."
    />
  );
}
